import { Params } from '@angular/router';

const UTM_MEDIUM = 'qrcode_ecd';

export const PhygitalHelper = {
    constructRedirectUrl(redirectUrl: string, queryParams: Params): string {
        const mobileID: string | undefined = queryParams?.['mobile'];
        let rawReturnUrl = mobileID ? `${redirectUrl}/${mobileID}?` : `${redirectUrl}?`;
        Object.keys(queryParams).forEach((queryName) => {
            if (queryName !== 'mobile') {
                rawReturnUrl =
                    queryName === 'utm_medium'
                        ? rawReturnUrl.concat(queryName, '=', UTM_MEDIUM, '&')
                        : rawReturnUrl.concat(queryName, '=', queryParams[queryName], '&');
            }
        });
        return rawReturnUrl.slice(0, rawReturnUrl.lastIndexOf('&'));
    },
};
